/**
 * Joins breadcrumb-style header segments into a single title string,
 * separated by ` > `. Returns an empty string when `items` is empty.
 */
export default function headerToTitle(items: string[]): string {
    return items.join(' > ');
}
